import React, { useState, useEffect } from "react";
import CommonTable from "../../components/commonComponent/CommanTable";
import CommonModal from "../../components/commonComponent/CommonModal";
import { FaPencilAlt } from "react-icons/fa";

// Modal fields (same as add/edit modal)
const solarPartnerFields = [
  { type: "heading", label: "Basic Information" },
  { name: "clientId", label: "Client ID", type: "text", placeholder: "Client ID" },
  { name: "companyName", label: "Company Name", type: "text", placeholder: "Company Name" },
  { name: "firstName", label: "First Name", type: "text", placeholder: "First Name" },
  { name: "lastName", label: "Last Name", type: "text", placeholder: "Last Name" },
  { name: "city", label: "City", type: "select", options: [
      { value: "Rajkot", label: "Rajkot" },
      { value: "Ahmedabad", label: "Ahmedabad" },
      { value: "Surat", label: "Surat" },
      { value: "Mumbai", label: "Mumbai" },
      { value: "Bangalore", label: "Bangalore" },
    ], placeholder: "Select City"
  },
  { name: "state", label: "State", type: "select", options: [
      { value: "Gujarat", label: "Gujarat" },
      { value: "Punjab", label: "Punjab" },
      { value: "Maharashtra", label: "Maharashtra" },
      { value: "Karnataka", label: "Karnataka" },
    ], placeholder: "Select State"
  },
  { type: "heading", label: "Contact Information" },
  { name: "mobileNumber", label: "Mobile Number", type: "text", placeholder: "Mobile Number" },
  { name: "email", label: "Email", type: "email", placeholder: "Email" },
  { type: "heading", label: "Business Information" },
  { name: "gstNumber", label: "GST Number", type: "text", placeholder: "GST Number" },
  { type: "heading", label: "Plan Information" },
  { name: "plan", label: "Select Plan", type: "select", options: [], placeholder: "Select Plan" },
];

// Dummy Data for partner
const initialPartnerInfo = {
  firstName: "Jenny",
  lastName: "Wilson",
  companyName: "Innoveza",
  clientId: "SE0001",
  mobileNumber: "1234567890",
  email: "Abcdfs20012@Gmail.Com",
  city: "Rajkot",
  state: "Gujarat",
  gstNumber: "213232343223",
  plan: "Basic",
};

// Dummy log data
const logRows = [
  {
    srNo: 1,
    moduleName: "Lead",
    action: "Created",
    actionBy: "Abcdfs20012@Gmail.Com",
    dateTime: "29/12/2025 (9:00AM)",
    whatAction: "Lead Created Successfully",
  },
];

const logColumns = [
  { key: "srNo", label: "Sr.no:" },
  { key: "moduleName", label: "Module Name" },
  { key: "action", label: "Action" },
  { key: "actionBy", label: "Action By" },
  { key: "dateTime", label: "Date &time" },
  { key: "whatAction", label: "What Action" },
];

const billingRows = [
  {
    srNo: 1,
    invoiceNumber: "SEEE0001",
    package: "Lifetime",
    company: "Innoveza",
    paymentDate: "17/08/2025",
    nextPaymentDate: "25/08/2025",
    transactionId: "Eregaterewel12",
    gstNumber: "213232343223",
    amount: "$ 5,000.00",
    paymentMode: "Offline",
    actions: <span style={{ cursor: "pointer" }}>⋮</span>,
  },
];

const billingColumns = [
  { key: "srNo", label: "Sr.no:" },
  { key: "invoiceNumber", label: "Invoice Number" },
  { key: "package", label: "Package" },
  { key: "company", label: "Company" },
  { key: "paymentDate", label: "Payment date" },
  { key: "nextPaymentDate", label: "Next Payment date" },
  { key: "transactionId", label: "Transaction Id" },
  { key: "gstNumber", label: "GST Number" },
  { key: "amount", label: "Amount" },
  { key: "paymentMode", label: "Payment Mode" },
];

function SolarView() {
  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(initialPartnerInfo);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [plans, setPlans] = useState([]);

  // Search state for billing table
  const [billingSearch, setBillingSearch] = useState("");
  const filteredBillingRows = billingRows.filter(row =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(billingSearch.toLowerCase())
  );

  // Fetch plans from API
  useEffect(() => {
    async function fetchPlans() {
      try {
        const res = await fetch("/api/plan");
        const data = await res.json();
        if (data.Status === 1) {
          setPlans(data.plans.map(plan => ({ value: plan._id, label: plan.name })));
        }
      } catch (e) {
        console.error("Failed to fetch plans");
      }
    }
    fetchPlans();
  }, []);

  // Update solarPartnerFields with dynamic plans
  const dynamicSolarPartnerFields = solarPartnerFields.map(field => {
    if (field.name === "plan") {
      return { ...field, options: plans };
    }
    return field;
  });

  // Edit button handler
  const handleEditClick = () => {
    setModalData(initialPartnerInfo);
    setErrors({});
    setShowModal(true);
  };

  // Modal submit handler (implement validation if needed)
  const handleSubmit = () => {
    // Here you would validate and submit changes
    setShowModal(false);
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 1200 }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2 className="fw-bold text-dark">Solar Partner Details</h2>
        <div>
          <a href="/admin" className="text-dark text-decoration-none">
            &larr; Dashboard
          </a>
        </div>
      </div>
      {/* Basic Info Card */}
      <div
        className="mb-4 mt-4 "
        style={{
          background: "#fff",
          border: "1px solid #e3e6ef",
          borderRadius: "12px",
          boxShadow: "0 1px 5px 0 #f3f4f8",
          padding: "24px 18px",
        }}
      >
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            <div className="fw-bold fs-4 mb-2 text-dark">Basic info</div>
            <div className="row">
              <div className="col-md-7">
                <div className="fw-semibold mb-1 text-dark">Basic Information</div>
                <div>{modalData.firstName} {modalData.lastName}</div>
                <div>{modalData.companyName}</div>
                <div>Client Id: {modalData.clientId}</div>
              </div>
              <div className="col-md-5">
                <div className="fw-semibold mb-1 text-dark">
                  Contact Information
                </div>
                <div>
                  <span className="me-2">
                    <span role="img" aria-label="mobile">MobileNumber</span> {modalData.mobileNumber}
                  </span>
                </div>
                <div>
                  <span className="me-2">
                    <span role="img" aria-label="email">Email</span> {modalData.email}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button
            className="btn btn-light border rounded-circle shadow-sm"
           
            title="Edit"
            onClick={handleEditClick}
          >
            <FaPencilAlt />
          </button>
        </div>
      </div>

      {/* Log Table */}
      <div>
        <div className="fw-bold fs-4 mb-2 text-dark">Log</div>
        <CommonTable
          columns={logColumns}
          data={logRows}
          itemsPerPageOptions={[15]}
          defaultItemsPerPage={15}
          tableClassName="mb-4"
          
          bordered
        />
      </div>

      {/* Billing Details Table */}
      <div className="mt-4">
        <div className="fw-bold fs-4 mb-2 text-dark">Billing Details</div>
        <div className="d-flex justify-content-end mb-2">
          <div className="input-group" style={{ maxWidth: 260 }}>
            <span className="input-group-text bg-white">
              <i className="fas fa-search text-muted"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Type to search"
              value={billingSearch}
              onChange={e => setBillingSearch(e.target.value)}
              style={{ boxShadow: "none" }}
            />
          </div>
        </div>
        <CommonTable
          columns={billingColumns}
          data={filteredBillingRows}
          itemsPerPageOptions={[15]}
          defaultItemsPerPage={15}
          tableClassName="mb-4"
          bordered
        />
      </div>

      {/* Edit Modal */}
      <CommonModal
        visible={showModal}
        title="Edit Solar Partner"
        fields={dynamicSolarPartnerFields}
        values={modalData}
        onChange={setModalData}
        onCancel={() => setShowModal(false)}
        onSubmit={handleSubmit}
        submitLabel={isSubmitting ? "Updating..." : "Update"}
        cancelLabel="Cancel"
        requiredFields={[
          "clientId",
          "companyName",
          "firstName",
          "lastName",
          "city",
          "state",
          "mobileNumber",
          "email",
          "gstNumber",
          "plan",
        ]}
        errors={errors}
        disabled={isSubmitting}
      />
    </div>
  );
}

export default SolarView;